export const FEATURES = {
    dashboard: 'Dashboard',
    products: 'Products',
    configurators: 'Configurators',
    serviceBooking: 'Service Booking',
    imports: 'Imports',
    reports: 'Reports',
    settings: 'Settings',
    setup: 'Setup',
} as const;

export const PRODUCT_GUIDES = {
    guide: 'Product guide',
    configurator: 'Product configurator',
    builder: 'Configurator and product guide builder',
} as const;
